import { LiveClassDto, LiveClassServiceDto } from '../shared/types/LiveClassDto';
import { findTimeZone, getUnixTime } from 'timezone-support';

export class LiveClassHelpers {
  static convertArrayToDate(value: number[], tzName = 'America/New_York') {
    if (!value || value.length > 7 || value.length < 3) {
      return;
    }
    const tz = findTimeZone(tzName);
    const year = value[0];
    const month = value[1];
    const day = value[2];
    const hours = (value && value[3]) || 0;
    const minutes = (value && value[4]) || 0;
    const seconds = (value && value[5]) || 0;
    const milliseconds = (value && value[6]) || 0;
    const time = { year, month, day, hours, minutes, seconds, milliseconds };
    const newDate = new Date(getUnixTime(time, tz));
    return newDate.getTime();
  }

  static convertLiveClassesArrayToDate(liveClassSchedules: Array<LiveClassServiceDto>): Array<LiveClassDto> {
    return liveClassSchedules.map((liveClassSchedule: LiveClassServiceDto) => {
      return {
        ...liveClassSchedule,
        classBegin: LiveClassHelpers.convertArrayToDate(liveClassSchedule.classBegin),
        classEnd: LiveClassHelpers.convertArrayToDate(liveClassSchedule.classEnd),
      };
    });
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class.helpers.ts